<template>

  <v-container style="margin-top:0px; padding-top:0px;">

    <v-row align="center" >
      <v-col offset-lg="1" lg="10" offset-xl="2" xl="8"  align="center" >

        <br>
        <v-row>
          <v-col>
            <h2 align="center">{{ $t('views.home.collections') }}</h2>
            <br>
          </v-col>
        </v-row>

        <v-row align="center" >
          <v-col v-for="(category, i) in categories" cols="4" align="center" >
            <router-link tag="div" align="center" justify="center" :to="'/collection/' + category.slug">
              <v-img :src="category.image_url" :alt="category.name"></v-img>
              <span style="font-size:10pt;">{{category.name}}</span>
            </router-link>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// @ is an alias to /src
import CategoryService from "@/services/CategoryService.js"

export default {
  name: 'home',
  components: {

  },
  computed: {
    locale () {
      if (!this.$store.state.app.locale) {
        // Set default locale
        return {code: process.env.VUE_APP_I18N_LOCALE}
      }
      return this.$store.state.app.locale
    }
  },
  data: () => ({
    categories: []
  }),
  mounted () {
    this.getCategories();
  },
  methods: {
    async getCategories() {
      let channelRootCategory = this.$store.state.app.channel.root_category_id;
      CategoryService.methods.getCategories(channelRootCategory)
      .then(response => {
          // store.commit('mutateMenuItems', listItems);
          // this.items = store.state.app.menuItems
          this.categories = response.data.data;
       }).catch(error => {
         console.log(error);
       })
    },
    track() {
      console.log('tracking pageview')
      _paq.push(['setCustomUrl', this.$route.fullPath]);
      _paq.push(['setDocumentTitle', 'Categories Overview']);
      _paq.push(['trackPageView']);
    }
  }
};
</script>


<style scoped>

</style>
